module.exports = __webpack_public_path__ + "static/media/temp-wody-grzanie.332608d9.svg";